module.exports = __webpack_public_path__ + "img/Bodice-Front-B3-Db-Ed.17c787ff.png";